import { atom } from 'recoil';

const productAnimationState = atom({
  key: 'productAnimationState',
  default: null,
});

export { productAnimationState };
